module.exports = __webpack_public_path__ + "static/media/2.82f07f8b.jpg";